import styled from 'styled-components'

import { Filter } from './Filter'
import { useExposureList } from './useExposureList'
import { MediaItem } from '@/components/elements/News/MediaItem'
import { Pagination } from '@/components/elements/Pagination'
import { Spacer } from '@/components/elements/Spacer'
import { getYearOptions } from '@/components/pages/News/dateOptions'

import { useFadeTransition } from '@/hooks/useFadeTransition'
import type { Exposure } from '@/types/exposure'

type Props = {
  mediaExposureList: readonly Exposure[]
  mediaTypeList: readonly string[]
}

export const MediaList = ({ mediaExposureList, mediaTypeList }: Props) => {
  const COUNT_PER_PAGE = 30

  const {
    selectedTags,
    displayMediaList,
    currentPage,
    totalCount,
    changeSelectedYear,
    changeSelectedMonth,
    changeSelectedTag,
    transitionPage,
    handleAllTags,
  } = useExposureList(mediaExposureList, COUNT_PER_PAGE)
  const { render, transitionFn } = useFadeTransition(300)

  return (
    <>
      <Filter
        selectedTags={selectedTags}
        mediaTypeList={mediaTypeList}
        yearOptions={getYearOptions(mediaExposureList)}
        changeSelectedYear={(e) => transitionFn(() => changeSelectedYear(e))}
        changeSelectedMonth={(e) => transitionFn(() => changeSelectedMonth(e))}
        changeSelectedTag={(text) =>
          transitionFn(() => changeSelectedTag(text))
        }
        handleAllTags={handleAllTags}
      />
      <Spacer h={{ sp: 40, pc: 80 }} />
      {render(
        <List>
          {displayMediaList.length > 0 ? (
            displayMediaList.map((item) => (
              <MediaItem key={item._id} {...item} />
            ))
          ) : (
            <Message>一致する情報がみつかりませんでした</Message>
          )}
        </List>
      )}
      {totalCount > 0 && (
        <>
          <Spacer h={{ sp: 47, pc: 77 }} />
          <Pagination
            totalCount={totalCount}
            countPerPage={COUNT_PER_PAGE}
            currentPage={currentPage}
            transitionPage={(page) => transitionFn(() => transitionPage(page))}
          />
        </>
      )}
    </>
  )
}

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const Message = styled.h3`
  font-size: 16px;
  letter-spacing: 0.64px;
  line-height: 26px;

  @media screen and (max-width: 1047px) {
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0;
  }
`
